/* istanbul ignore file */
import type {CustomCssVarsFnParams, ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';

export const mobileFiltersAndSortCustomCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const {gallery_sortingFiltersTextColor} = styleParams.colors;
  const {galleryShowFilters} = styleParams.booleans;

  return {
    mobileSortContainerWidth: galleryShowFilters ? '52px' : '100%',
    mobileSortWithFiltersWrapperWidth: galleryShowFilters ? '40px' : '100%',
    mobileSortWithFiltersWrapperMarginInlineStart: galleryShowFilters ? '12px' : '0',
    mobileSortWithFiltersIconJustifyContent: galleryShowFilters ? 'center' : 'flex-end',
    mobileSortWithoutFiltersSelectPaddingInlineStart: !galleryShowFilters ? '12px' : '0',
    mobileSortWithoutFiltersSelectColor: !galleryShowFilters ? gallery_sortingFiltersTextColor : '0,0,0,0',
  };
};

export const mobileFiltersAndSortShouldRenderVars = ({booleans}: ShouldRenderVarsFnParams) => {
  const {galleryShowFilters, galleryShowSort} = booleans;
  const shouldRenderMobileFiltersAndSortButtonText = galleryShowFilters && galleryShowSort;
  const shouldRenderMobileFiltersButtonText = galleryShowFilters && !galleryShowSort;
  const shouldRenderMobileSortButtonText = !galleryShowFilters && galleryShowSort;
  const shouldRenderMobileSortButtonIconWhenFiltersDisabled = !galleryShowFilters;

  return {
    shouldRenderMobileFiltersAndSortButtonText,
    shouldRenderMobileFiltersButtonText,
    shouldRenderMobileSortButtonText,
    shouldRenderMobileSortButtonIconWhenFiltersDisabled,
  };
};
